import styled from "styled-components";
import { colors, font, radius, shadow } from "../../../styles/theme/tokens";

// Форма «Додати учня» в нових стилях платформи (токени styles/theme/tokens.js)

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
  max-width: 780px;
  margin: 0 auto 40px;
  font-family: ${font.text};
  color: ${colors.ink};
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border-radius: ${radius.xl};
  background: ${colors.surface};
  box-shadow: ${shadow.card};

  @media (max-width: 600px) {
    padding: 18px 16px;
    border-radius: ${radius.lg};
  }
`;

export const SectionTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 18px;
  font-weight: 800;

  span {
    display: grid;
    place-items: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    font-size: 14px;
    color: #FFFFFF;
    background: ${colors.brand};
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;

export const Label = styled.span`
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${colors.muted};
`;

export const Optional = styled.small`
  font-size: 11px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
`;

export const Input = styled.input`
  width: 100%;
  min-width: 0;
  padding: 12px 14px;
  border-radius: ${radius.md};
  border: 2px solid ${(props) => (props.$error ? colors.danger : colors.line)};
  font-family: ${font.text};
  font-size: 15px;
  color: ${colors.ink};
  background: ${colors.surface};
  outline: none;
  transition: border-color 0.15s ease;

  &::placeholder {
    color: #B3B0CC;
  }

  &:focus {
    border-color: ${colors.brand};
  }
`;

export const InputRow = styled.div`
  display: flex;
  gap: 8px;
`;

export const IconButton = styled.button`
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 48px;
  border: none;
  border-radius: ${radius.md};
  color: ${colors.brandDeep};
  background: ${colors.brandSoft};
  cursor: pointer;

  &:hover {
    background: ${colors.line};
  }
`;

export const Error = styled.small`
  font-size: 12px;
  font-weight: 600;
  color: ${colors.danger};
`;

export const Placeholder = styled.span`
  font-size: 14px;
  color: ${colors.muted};
`;

export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Chip = styled.button`
  padding: 9px 16px;
  border-radius: ${radius.pill};
  border: 2px solid ${(props) => (props.$active ? colors.brandDeep : colors.line)};
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 700;
  text-transform: capitalize;
  color: ${(props) => (props.$active ? "#FFFFFF" : colors.ink)};
  background: ${(props) => (props.$active ? colors.brand : colors.surface)};
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: ${colors.brand};
  }
`;

export const PickerButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-height: 48px;
  padding: 10px 14px;
  border-radius: ${radius.md};
  border: 2px solid ${(props) => (props.$error ? colors.danger : props.$open ? colors.brand : colors.line)};
  font-family: ${font.text};
  font-size: 15px;
  text-align: left;
  color: ${colors.ink};
  background: ${colors.surface};
  cursor: pointer;

  small {
    margin-left: 4px;
    font-size: 12px;
    color: ${colors.muted};
  }
`;

export const Clear = styled.span`
  display: grid;
  place-items: center;
  color: ${colors.muted};

  &:hover {
    color: ${colors.danger};
  }
`;

export const PickerList = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 20;
  max-height: 280px;
  overflow-y: auto;
  padding: 6px;
  border-radius: ${radius.md};
  background: ${colors.surface};
  box-shadow: ${shadow.raised};
`;

export const Search = styled.label`
  position: sticky;
  top: -6px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: -6px -6px 6px;
  padding: 10px 12px;
  border-bottom: 1px solid ${colors.line};
  color: ${colors.muted};
  background: ${colors.surface};

  input {
    flex: 1;
    min-width: 0;
    border: none;
    outline: none;
    font-family: ${font.text};
    font-size: 14px;
    color: ${colors.ink};
  }
`;

export const PickerItem = styled.button`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: ${radius.sm};
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  color: ${colors.ink};
  background: ${(props) => (props.$active ? colors.brandSoft : "transparent")};
  cursor: pointer;

  small {
    font-size: 12px;
    color: ${colors.muted};
  }

  &:hover {
    background: ${colors.brandSoft};
  }
`;

export const Empty = styled.p`
  padding: 10px 12px;
  font-size: 14px;
  color: ${colors.muted};
`;

export const DayRow = styled.div`
  display: grid;
  grid-template-columns: 48px minmax(0, 180px);
  align-items: center;
  gap: 12px;

  b {
    font-weight: 800;
  }
`;

export const Alert = styled.p`
  padding: 12px 16px;
  border-radius: ${radius.md};
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 600;
  color: ${colors.danger};
  background: ${colors.dangerSoft};
`;

export const Primary = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px 24px;
  border: none;
  border-radius: ${radius.lg};
  font-family: ${font.text};
  font-size: 17px;
  font-weight: 800;
  color: #FFFFFF;
  background: ${colors.brand};
  box-shadow: ${shadow.button(colors.brandDeep)};
  cursor: pointer;
  transition: transform 0.1s ease;

  &:active {
    transform: translateY(2px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const Secondary = styled(Primary)`
  color: ${colors.brandDeep};
  background: ${colors.brandSoft};
  box-shadow: none;
`;

export const Done = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  max-width: 520px;
  margin: 40px auto;
  padding: 36px 28px;
  border-radius: ${radius.xl};
  font-family: ${font.text};
  text-align: center;
  color: ${colors.ink};
  background: ${colors.surface};
  box-shadow: ${shadow.card};

  h2 {
    margin: 0;
    font-size: 22px;
    font-weight: 800;
  }

  p {
    margin: 0;
    color: ${colors.muted};
  }
`;

export const DoneIcon = styled.span`
  display: grid;
  place-items: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  color: #FFFFFF;
  background: ${colors.success};
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-top: 8px;
`;
